import React from "react";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export default function Group({
  title,
  field_name,
  error,
  required,
  onChange,
  values,
  borderColor,
  value,
  setActiveElement,
}) {
  const { t } = useTranslation();

  const [selected, setSelected] = React.useState(false);

  const options = [
    { value: "Yes", label: t("yes") },
    { value: "No", label: t("no") },
  ];

  return (
    <div className="w-full group">
      <label className="block text-sm font-normal mb-2 ml-1">
        {title}
        {`${required ? "*" : ""}`}
      </label>
      <RadioGroup
        value={value}
        onChange={(inputValue) => {
          setSelected(true);
          onChange(field_name, inputValue);
          setActiveElement(field_name);
        }}
        name={field_name}
        className="flex w-full text-sm items-center"
        style={{ borderColor: error ? "#dc2626" : borderColor }}
      >
        {options.map((option, index) => (
          <RadioGroup.Option
            key={option.value}
            value={option.value}
            className="w-1/2 text-center"
          >
            {({ checked }) => (
              <div
                className={`
                  ${!selected ? "text-gray-900" : "text-gray-400"}
                  ${checked ? "font-semibold text-gray-900" : ""}
                  ${selected && !checked ? "text-gray-400" : ""}
                  border p-2 h-12 items-center flex justify-center cursor-pointer
                  ${index === 0 ? "rounded-l-lg" : "rounded-r-lg"}
                `}
                style={{
                  background: `${
                    checked
                      ? "linear-gradient(180deg, #dad5d5 0%, #FFFFFF 100%)"
                      : "#FFFFFF"
                  }`,
                }}
              >
                {option.label}
              </div>
            )}
          </RadioGroup.Option>
        ))}
      </RadioGroup>
    </div>
  );
}
